import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca80a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "screenshot"
}
const _hoisted_2 = {
  key: 0,
  class: "screenshot-loading"
}
const _hoisted_3 = { class: "screenshot-buttons" }
const _hoisted_4 = { class: "sliderText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "しばらくお待ちください"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "slider",
            type: "range",
            min: "9",
            max: "13",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sliderValue) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSliderChange && _ctx.onSliderChange(...args)))
          }, null, 544), [
            [_vModelText, _ctx.sliderValue]
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.sliderText), 1),
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
          }, "スクリーンショット")
        ])
      ]))
    : _createCommentVNode("", true)
}